<template>
    <vue-suggestions
        :model="value"
        :coordinates.sync="coordinates"
        :placeholder="'Начните вводить адрес'"
        :options="suggestionOptions"
        @update:model="handleChange"
    />
</template>
<script>
import _ from 'lodash';
import '@/assets/styles/suggestions.scss';
import VueSuggestions from 'vue-suggestions';
import localReferences from '@/helpers/localReferences';

export default {
    name: 'VueSuggestionsAddress',
    props: {
        value: {
            type: String,
            default: ''
        },
        dropdownClass: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            city: '',
            coordinates: {
                latitude: '',
                longitude: ''
            },
            suggestionOptions: {
            }
        };
    },
    methods: {
        handleChange: _.debounce(function(value) {
            this.$emit('input', value);
            if (value.length === 0) {
                this.$emit('handleCoordinates', '');
            } else {
                this.$store.dispatch('map/getCoordinatesByAddress', encodeURIComponent(value)).then(
                    res => {
                        const coords = res || localReferences.mapCenterCoordinates;
                        this.$emit('handleCoordinates', coords.join(' '));
                    }).catch(
                    error => {
                        console.log(error);
                    });
            }
        }
        , 1000)
    },
    created() {
        this.suggestionOptions = {
            token: this.$store.getters.daDataApiKey,
            type: 'ADDRESS',
            constraints: [
                {
                    label: '',
                    locations: { region: 'Москва' }
                },
                {
                    label: '',
                    locations: { kladr_id: '50' }
                }
            ],
            scrollOnFocus: false,
            triggerSelectOnBlur: false,
            triggerSelectOnEnter: false,
            addon: 'none',
            onSelect: suggestion => {
                this.$emit('handleAddress', suggestion.value);
                if (suggestion.data.geo_lat && suggestion.data.geo_lon) {
                    this.$emit('handleCoordinates', suggestion.data.geo_lat + ' ' + suggestion.data.geo_lon);
                }
            }
        };
    },
    components: { VueSuggestions }
};
</script>
